import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const quickLinks = [
    { label: '新手入门', path: '/category/beginner' },
    { label: '角色攻略', path: '/category/character' },
    { label: '隐藏内容', path: '/category/hidden' },
    { label: '进阶技巧', path: '/category/advanced' },
    { label: '资源大全', path: '/category/resource' },
  ];

  const resourceLinks = [
    { label: '关于我们', path: '/about' },
    { label: '全部攻略', path: '/category/all' },
    { label: '常见问题', path: '/#faq' },
  ];

  return (
    <footer className="bg-background-900 text-foreground-300">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-gamepad-line text-white text-lg"></i>
              </div>
              <span className="text-lg font-semibold text-white font-heading whitespace-nowrap">
                {t('site.name')}
              </span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-400">
              {t('footer.copyright')}
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">{t('footer.links')}</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">{t('footer.resources')}</h4>
            <ul className="space-y-2.5">
              {resourceLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">{t('footer.contact')}</h4>
            <div className="space-y-2.5 text-sm text-foreground-400">
              <p className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                buttergame@example.com
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-wechat-line"></i>
                ButterGame_Official
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-qq-line"></i>
                123456789
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 {t('site.name')}. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors text-xs" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors text-xs" rel="nofollow">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}